import { useContext } from 'react';
import { CharitableGivingContext } from './CharitableGivingProvider';

export const useCharitableGivingContext = () => {
  const context = useContext(CharitableGivingContext);

  if (context === undefined) {
    throw new Error('useCharitableGivingContext must be used within a CharitableGivingProvider');
  }

  return context;
};
